"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uri = require("urijs");
var _ = require("underscore");
/**
 * Regex for matching URIs.
 * @const
 * @type {RegExp}
 */
var URI_REGEX = /^([a-z0-9+.-]+):(?:\/\/(?:((?:[a-z0-9-._~!$&'()*+,;=:]|%[0-9A-F]{2})*)@)?((?:[a-z0-9-._~!$&'()*+,;=]|%[0-9A-F]{2})*)(?::(\d*))?(\/(?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*)?|(\/?(?:[a-z0-9-._~!$&'()*+,;=:@]|%[0-9A-F]{2})+(?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*)?)(?:\?((?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?(?:#((?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?$/i;
var UrlBuilderContext = (function () {
    /**
     * Creates a new `UrlBuilderContext`. This is the actual source of URLs from UrlBuilder.
     *
     * Since there may be multiple base paths coming from a UrlBuilder, all of which are handled in the same way, this gives us a method of not repeating ourselves.
     * @param {String} basePath The base URI path to which all resultant URLs are relative.
     * @constructor
     */
    function UrlBuilderContext(basePath) {
        this._basePath = basePath;
    }
    /**
     * Normalizes a URL.
     * @param  {string} path         The path to normalize.
     * @param  {Boolean} [leadingSlash] True to include a leading slash, otherwise false. If unspecified, the input path will be examined, and its leading slash, or lack thereof, will be preserved. The trailing slash state is always preserved.
     * @return {String}              The normalized URL.
     * @example
     * this.url('/some/other/place');
     * //returns '/api/some/other/place' when running at root.
     * this.url('some/other/place', true);
     * //returns '/api/some/other/place' when running at root
     * this.url('');
     * //returns '/api' when running at root.
     * this.url('/somewhere', true, true);
     * //returns '/somewhere'
     * this.url('some/other/place', false);
     * //returns 'api/some/other/place'
     */
    UrlBuilderContext.prototype.url = function (path, leadingSlash) {
        if (path === void 0) { path = ''; }
        var result = path, pathUri = UrlBuilder.uri(result), basePath = this._basePath, basePathUri = UrlBuilder.uri(basePath), hasLeadingSlash = false, hasTrailingSlash = false;
        if (!pathUri.is('absolute')) {
            var prefix = basePath;
            if (result.length > 0) {
                if (result[0] !== '/' && prefix.length && prefix !== '/') {
                    prefix = prefix + '/';
                }
            }
            else {
                if (!prefix.length) {
                    prefix += '/';
                }
            }
            result = pathUri.toString();
            if ((prefix + _.first(result)) !== '//') {
                result = prefix + result;
            }
            if (path.length) {
                if (path[0] == '/') {
                    hasLeadingSlash = true;
                    if (path.length > 1 && (path[path.length - 1] == '/')) {
                        hasTrailingSlash = true;
                    }
                }
                else {
                    if (path[path.length - 1] == '/') {
                        hasTrailingSlash = true;
                    }
                }
            }
            if (!basePathUri.is('absolute') && (_.isBoolean(leadingSlash) || hasLeadingSlash)) {
                if (leadingSlash || hasLeadingSlash) {
                    if (result.length && result[0] !== '/') {
                        result = '/' + result;
                    }
                }
                else {
                    if (result.length && result[0] == '/') {
                        result = result.substring(1);
                    }
                }
            }
            else if (result.length && result[0] == '/') {
                result = result.substring(1);
            } //no else is because if we don't know what to do, then we shouldn't do anything.
            if (result.length > 1) {
                if (hasTrailingSlash && (result[result.length - 1] != '/')) {
                    result = result + '/';
                }
                else if (!hasTrailingSlash && (result[result.length - 1] == '/')) {
                    result = result.substring(0, result.length - 1);
                }
            }
        }
        else {
            result = pathUri.toString();
        }
        return result;
    };
    return UrlBuilderContext;
}());
exports.UrlBuilderContext = UrlBuilderContext;
var UrlBuilder = (function () {
    /**
     * Creates a new `UrlBuilder`.
     * @param {String} slug A URL slug which all URLs will be relative to.
     * @param {String} [root] A root URL which all absolute URLs will be relative to.
     * @constructor
     */
    function UrlBuilder(slug, root) {
        this._slug = slug;
        this._root = root;
    }
    /**
     * Determine whether or not the given value is a URI.
     * @static
     * @param  value The value to check
     * @return {Boolean}       True if the given value is a URI string, otherwise false.
     */
    UrlBuilder.isUri = function (value) {
        return value && _.isString(value) && !!value.match(URI_REGEX);
    };
    UrlBuilder.prototype._createContext = function (basePath) {
        if (basePath.length > 1 && basePath.substring(basePath.length - 1) == '/') {
            basePath = basePath.substring(0, basePath.length - 1);
        }
        return new UrlBuilderContext(basePath);
    };
    /**
     * Normalizes a URL relative to the slug.
     * @param  {string} path         The path to normalize.
     * @param  {Boolean} [leadingSlash] True to include a leading slash, otherwise false. If unspecified, the input path will be examined, and its leading slash, or lack thereof, will be preserved. The trailing slash state is always preserved.
     * @return {String}              The normalized URL.
     * @example
     * this.url('/some/other/place');
     * //returns '/api/some/other/place' when running at root.
     * this.url('some/other/place', true);
     * //returns '/api/some/other/place' when running at root
     * this.url('');
     * //returns '/api' when running at root.
     * this.url('/somewhere', true, true);
     * //returns '/somewhere'
     * this.url('some/other/place', false);
     * //returns 'api/some/other/place'
     */
    UrlBuilder.prototype.url = function (path, leadingSlash) {
        return this.relative().url(path, leadingSlash);
    };
    /**
     * Creates a new UrlBuilder where all URLs are generated relative to the current root and slug and the given childPath.
     * @param {String} childPath The path at which the new UrlBuilder will be rooted.
     * @return {UrlBuilder} A UrlBuilder rooted at the new path.
     */
    UrlBuilder.prototype.child = function (childPath) {
        var uri = UrlBuilder.uri(this._slug);
        uri = uri.segment(childPath);
        return new UrlBuilder(uri.toString(), this._root);
    };
    /**
     * Returns the `UrlBuilderContext` for generating absolute URLs.
     * @return {UrlBuilderContext} A URL builder context.
     */
    UrlBuilder.prototype.absolute = function () {
        var ctx;
        if (!!this._slug) {
            ctx = this._createContext(UrlBuilder.uri(this._root).segment(this._slug).toString());
        }
        else {
            ctx = this._createContext(UrlBuilder.uri(this._root).toString());
        }
        return ctx;
    };
    /**
     * Returns the `UrlBuilderContext` for generating relative URLs.
     * @return {UrlBuilderContext} A URL builder context.
     */
    UrlBuilder.prototype.relative = function () {
        return this._createContext(UrlBuilder.uri(this._slug).toString());
    };
    /**
     * A reference to the root of the URI.js toolchain.
     * @see http://medialize.github.io/URI.js/
     */
    UrlBuilder.uri = uri;
    return UrlBuilder;
}());
exports.default = UrlBuilder;
//# sourceMappingURL=url-builder.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@HBKEngineering/url-builder/lib/url-builder.js
// module id = 145
// module chunks = 1